import { useMultiStepFormStore } from "@/stores";
import { CollapsibleCard } from "@/ui";
import { getCards } from "./getCards";

export const CardsSection = () => {
  const { multiStepFormData } = useMultiStepFormStore();

  if (!multiStepFormData) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4">
      {getCards(multiStepFormData).map((card, index) =>
        card.isCompleted ? (
          <CollapsibleCard
            key={index}
            title={card.title}
            icon={card.icon}
            data={card.data}
          />
        ) : null,
      )}
    </div>
  );
};
